import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import InteractiveTileContainer from './interactive.js';
import StaticTileContainer from './non-interactive.js';

/**
 * @component TileContainer
 * @package Tiles
 * @document ../_docs/code/TileContainer.editor.tsx
 * @document ../_docs/code/TileContainer.snippet.tsx
 * @document ../_docs/code/TileContainer.import.tsx
 */
const TileContainer = (_a) => {
    var props = __rest(_a, []);
    if (props.href || props.onClick)
        return jsx(InteractiveTileContainer, Object.assign({}, props));
    return jsx(StaticTileContainer, Object.assign({}, props));
};

export { TileContainer, TileContainer as default };
